module.exports = __webpack_public_path__ + "img/company10.3acaf315.png";